<template>
  <button
    class="bg-gray-100 text-gray-800 mt-4 py-1.5 px-4 text-center font-semibold w-full hidden xl:block"
    :disabled="(page === pages - 1)"
    :class="(page === pages - 1) ? ['cursor-default !text-gray-400'] : ''"
    @click="page++"
  >
    <span>Next Page</span>
    <i class="fa-solid fa-chevron-down block !text-sm text-center mx-auto" />
  </button>
</template>

<script setup>
const page = defineModel();

defineProps({
  pages: {
    type: Number,
    default: 0,
  },
});
</script>

<style scoped>

</style>
